import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class FractionalUnitsType extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, FractionalUnitsType._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static PIXELS = new AString('px');
    public static PERCENTAGES = new AString('%');
    public static FRACTIONS = new AString('fr');
    public static AUTO = new AString('auto');

    private static _types:Array<AString> = [
        FractionalUnitsType.PIXELS,
        FractionalUnitsType.PERCENTAGES,
        FractionalUnitsType.FRACTIONS,
        FractionalUnitsType.AUTO,
    ];

    public static pixels():FractionalUnitsType
    {
        return new FractionalUnitsType(FractionalUnitsType.PIXELS);
    }

    public static percentages():FractionalUnitsType
    {
        return new FractionalUnitsType(FractionalUnitsType.PERCENTAGES);
    }

    public static fractions():FractionalUnitsType
    {
        return new FractionalUnitsType(FractionalUnitsType.FRACTIONS);
    }

    public static auto():FractionalUnitsType
    {
        return new FractionalUnitsType(FractionalUnitsType.AUTO);
    }

    public static isPixels(unitsType:FractionalUnitsType):boolean
    {
        return unitsType.value.value === FractionalUnitsType.PIXELS.value;
    }

    public static isPercentages(unitsType:FractionalUnitsType):boolean
    {
        return unitsType.value.value === FractionalUnitsType.PERCENTAGES.value;
    }

    public static isFractions(unitsType:FractionalUnitsType):boolean
    {
        return unitsType.value.value === FractionalUnitsType.FRACTIONS.value;
    }

    public static isAuto(unitsType:FractionalUnitsType):boolean
    {
        return unitsType.value.value === FractionalUnitsType.AUTO.value;
    }
}
